module.exports = __webpack_public_path__ + "static/media/pending_document.f15d0a5c.svg";